// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CourierModal.module.css */

/* Фон-маска */
.CourierModal_overlay__\\+iHT4 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  animation: CourierModal_modalShow__NrEcD 0.2s ease-out;
}

/* Окно модалки */
.CourierModal_modal__5QamT {
  position: relative;
  width: 85vw;
  max-width: 500px;

  height: 70vh;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Контейнер контента модалки */
.CourierModal_containerModal__MwU1R {
  flex: 1 1;
  position: relative;
  padding: 0; /* padding уже на .body */
}

/* Заголовок модалки */
.CourierModal_header__XDgzY {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 18px;
  font-weight: bold;
  text-align: center; /* <- добавлено для центрирования */
}


/* Тело модалки */
.CourierModal_body__UFcTj {
  flex: 1 1;
  overflow-y: auto;
}

/* Подвал модалки */

.CourierModal_footer__FF00I {
  padding: 0;
}
/* Кнопка закрытия модалки */
.CourierModal_closeButton__\\+vSkc {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: rgb(0, 123, 255);
  color: #fff;
  border: none;
  font-size: 18px;
  border-radius: 0;
  cursor: pointer;
  text-align: center;
  z-index: 100;
}

.CourierModal_closeButton__\\+vSkc:hover {
  background-color: rgb(0, 100, 255);
}


/* Дополнительный раздел внизу */
.CourierModal_totalModalSection__rHQ8A {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  height: 50px;
  font-size: 18px;
  text-align: center;
  z-index: 100;
}

/* Анимация появления */
@keyframes CourierModal_modalShow__NrEcD {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Адаптивность */
@media (max-width: 600px) {
  .CourierModal_modal__5QamT {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/CourierModal.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sDAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU,EAAE,yBAAyB;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB,EAAE,mCAAmC;AACzD;;;AAGA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,UAAU;AACZ;AACA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;;AAGA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* CourierModal.module.css */\r\n\r\n/* Фон-маска */\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: auto;\r\n  animation: modalShow 0.2s ease-out;\r\n}\r\n\r\n/* Окно модалки */\r\n.modal {\r\n  position: relative;\r\n  width: 85vw;\r\n  max-width: 500px;\r\n\r\n  height: 70vh;\r\n  background-color: #fff;\r\n  border-radius: 12px;\r\n  box-sizing: border-box;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Контейнер контента модалки */\r\n.containerModal {\r\n  flex: 1;\r\n  position: relative;\r\n  padding: 0; /* padding уже на .body */\r\n}\r\n\r\n/* Заголовок модалки */\r\n.header {\r\n  padding: 10px;\r\n  border-bottom: 1px solid #ddd;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  text-align: center; /* <- добавлено для центрирования */\r\n}\r\n\r\n\r\n/* Тело модалки */\r\n.body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Подвал модалки */\r\n\r\n.footer {\r\n  padding: 0;\r\n}\r\n/* Кнопка закрытия модалки */\r\n.closeButton {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 50px;\r\n  background-color: rgb(0, 123, 255);\r\n  color: #fff;\r\n  border: none;\r\n  font-size: 18px;\r\n  border-radius: 0;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  z-index: 100;\r\n}\r\n\r\n.closeButton:hover {\r\n  background-color: rgb(0, 100, 255);\r\n}\r\n\r\n\r\n/* Дополнительный раздел внизу */\r\n.totalModalSection {\r\n  position: absolute;\r\n  bottom: 10px;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 110%;\r\n  height: 50px;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  z-index: 100;\r\n}\r\n\r\n/* Анимация появления */\r\n@keyframes modalShow {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 600px) {\r\n  .modal {\r\n    width: 90%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CourierModal_overlay__+iHT4`,
	"modalShow": `CourierModal_modalShow__NrEcD`,
	"modal": `CourierModal_modal__5QamT`,
	"containerModal": `CourierModal_containerModal__MwU1R`,
	"header": `CourierModal_header__XDgzY`,
	"body": `CourierModal_body__UFcTj`,
	"footer": `CourierModal_footer__FF00I`,
	"closeButton": `CourierModal_closeButton__+vSkc`,
	"totalModalSection": `CourierModal_totalModalSection__rHQ8A`
};
export default ___CSS_LOADER_EXPORT___;
